import Component from 'flarum/common/Component';
import WechatQrcodeModal from './WechatQrcodeModal';
import { isInWechat, buildAuthUrl } from '../utils/wechat';

/**
 * 微信登录按钮。
 *
 * 两种模式（后台「登录模式」决定）：
 *  - open（默认）：开放平台网站应用扫码，走 connect/qrconnect，任意浏览器可用
 *  - mp：公众号网页授权，走 connect/oauth2/authorize，
 *        只能在微信内置浏览器里打开，PC 端点了微信会报错
 *
 * 授权后微信带 code 跳回 /auth/wechat（后端回调处理登录）。
 */

export default class WechatLoginButton extends Component {
  view() {
    const cfg = (app.data && app.data.acmeWechat) || {};
    const mode = cfg.mode || 'open';

    return mode === 'mp' ? this.mpButton(cfg) : this.openButton(cfg);
  }

  // 开放平台：扫码登录
  openButton(cfg) {
    const appId = cfg.appId;

    return (
      <a className="Button Button--wechat" href={appId ? this.authUrl('open', appId) : '#'} onclick={!appId ? () => alert('微信登录未配置 AppID') : null}>
        {this.icon()}
        微信登录
      </a>
    );
  }

  // 公众号：微信内直接授权，PC 端引导扫码
  mpButton(cfg) {
    const appId = cfg.mpAppId;

    if (!appId) {
      return (
        <a className="Button Button--wechat" href="#" onclick={() => alert('微信登录未配置公众号 AppID')}>
          {this.icon()}
          微信登录
        </a>
      );
    }

    if (isInWechat()) {
      return (
        <a className="Button Button--wechat" href={this.authUrl('mp', appId)}>
          {this.icon()}
          微信登录
        </a>
      );
    }

    // 非微信浏览器：公众号网页授权用不了，改为展示公众号二维码引导关注
    return (
      <a
        className="Button Button--wechat"
        href="#"
        onclick={(e) => {
          e.preventDefault();

          if (cfg.mpQrcode) {
            app.modal.show(WechatQrcodeModal, { qrcode: cfg.mpQrcode, name: cfg.mpName });
          } else {
            alert('请在微信客户端中打开论坛使用微信登录');
          }
        }}
      >
        {this.icon()}
        微信登录
      </a>
    );
  }

  authUrl(mode, appId) {
    // 显式登录一律用 snsapi_userinfo / snsapi_login，要拿昵称头像建号。
    // （微信内静默自动登录走 utils/wechat.js 的 snsapi_base，不复用这里。）
    const scope = mode === 'mp' ? 'snsapi_userinfo' : 'snsapi_login';

    return buildAuthUrl(mode, appId, scope, window.location.pathname + window.location.search);
  }

  icon() {
    /*
     * fill 用 currentColor：图标颜色跟着按钮的 color 走（微信按钮是白字，图标即为白色），
     * 改主题色时不用再动这里。
     *
     * 坑：JSX 内部不能写行注释，否则会被当成普通文本渲染到页面上
     * （曾经在按钮里渲染出一长串中文注释）。
     */
    return (
      <span className="Button-icon">
        <svg viewBox="0 0 1024 1024" width="18" height="18" aria-hidden="true">
            <path fill="currentColor" d="M664 373c-12-126-118-221-247-221C263 152 153 256 153 389c0 72 39 136 100 180l-25 75 88-44c36 13 64 19 99 19 8 0 16 0 23-1-6-21-9-42-9-64 0-121 111-214 235-214zM435 273c22 0 37 16 37 37s-15 37-37 37-37-16-37-37 15-37 37-37zm-159 74c-22 0-37-16-37-37s15-37 37-37 37 16 37 37-16 37-37 37z" />
            <path fill="currentColor" d="M872 571c0-99-95-179-208-179-114 0-209 80-209 179 0 99 95 179 209 179 27 0 53-5 78-14l69 35-19-60c44-32 80-77 80-130zm-277-38c-16 0-29-12-29-28s13-28 29-28 29 12 29 28-13 28-29 28zm140 0c-16 0-29-12-29-28s13-28 29-28 29 12 29 28-13 28-29 28z" />
          </svg>
      </span>
    );
  }
}
